
export const LOGIN_STATUS = {
    INITIATED: "initiated",
    AUTHENTICATED: "authenticated",
    NO_AUTHENTICATED: "no-authenticated",
  };

  export const STORAGE_KEY = {
    AUTH_DATA: "app-auth",
    ITUS: "app-itus",
  };

  export const METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    // Add other methods as needed
};